import { render, staticRenderFns } from "./editView.vue?vue&type=template&id=d2095b64"
import script from "./editView.vue?vue&type=script&lang=js"
export * from "./editView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports